<template lang="pug">
  y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
    v-card
      v-card-title.px-5(:style="`background-color: ${$vuetify.theme.themes[$theme].basic600T16}`")
        v-row(no-gutters)
          v-col
            .h6.basic800--text {{ $t('manage_member') }}

      v-card-text.pa-0
        v-form(ref="form")
          v-layout.my-6(v-if="isFetching")
            v-row.fill-height.ma-0(align='center' justify='center')
              v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
          .selet-member-layout(v-else-if="!isFetching")
            .p1.primary500--text.px-6.mt-4 {{ $t('may_select', { count }) }}
            v-list.pa-4
              template(v-for="(member, index) in members")
                v-list-item(:key="member.id")
                  intel-avatar.ml-n1.mr-4(:code="member.user.avatar_code" :id="member.user.id" size="38")
                  v-list-item-content
                    .p2.textColorHint--text {{ member.role }}
                    .s1.textColor--text {{ member.user.first_name }} {{ member.user.last_name }}
                    .p2.textColor--text {{ member.user.email }}
                  v-list-item-action
                    y-checkbox(v-model="member.selected" @change="updateMember(member, index)")
                v-divider
    
      v-card-actions
        v-spacer
        v-btn(color='white', text @click='showModal = false')
          .button-Aa-medium.primary400--text {{ $t('cancel') }}
        v-btn.mr-2(color='textColorAccent' depressed height=32 @click='showModal = false')
          .button-AA-small.basic100--text {{ $t('save') }}

</template>

<script>
  import IntelAvatar from '@/components/IntelAvatar.vue'
  import { mapActions } from 'vuex'
  export default {
    name: 'EditMemberModal',
    props: ['open', 'company', 'count'],
    components: { IntelAvatar },
    data: () => ({
      isFetching: false,
      members: [],
      isLoading: false,
      companyName: '',
      rules: {
        not_empty: [val => (val || '').length > 0 || 'This field is required']
      }
    }),
    computed: {
      showModal: {
        get() {
          return this.open
        },
        set(newValue) {
          this.$emit('update:open', newValue)
        }
      }
    },
    mounted () {
      this.fetchMembers()
    },
    methods: {
      ...mapActions([
        'showMessage', 'updateCompany'
      ]),
      updateMember (member, index) {
        let status = 'inactive'
        if (member.selected) {
          status = 'active'
        }
        this.$axios.patch(`/members/${member.id}/`, { status: status})
          .then(() => {
            this.$axios.get(`/companies/${this.company.id}/`)
              .then(resp => {
                this.updateCompany(resp.data)
              })
              .catch(() => {})
          })
          .catch(() => {
            this.members[index].selected = !this.members[index].selected
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          })
      },
      fetchMembers() {
        this.isFetching = true
        let url = `/members/?page=1&page_size=-1&company=${this.company.id}&ordering=id&exclude_roles=5`
        this.$axios.get(url)
          .then((response) => {
            this.isFetching = false
            response.data.results.forEach(member => {
              const newMember = member
              newMember.selected = false
              if (member.status == 'active') {
                newMember.selected = true
              }
              this.members.push(newMember)
            })
          })
          .catch(() => {})
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>

<i18n>
{
  "en": {
    "may_select": "You may select up to {count} person for this plan"
  },
  "id": {
    "may_select": "Anda dapat memilih hingga {count} orang untuk paket ini"
  }
}
</i18n>
